/**
 * 创建uid
 * @param {Number} e uid长度，默认32位
 */
const randomString = e => {
    e = e || 32;
    const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz';
    let i = '';

    for (let a = t.length, n = 0; n < e; n++) i += t.charAt(Math.floor(Math.random() * a));

    return i;
};

export { randomString };
